import { isNil, omitBy } from 'lodash-es';
export const asArray = (thing) => (Array.isArray(thing) ? thing : [thing]);
export const chunkArray = (arr, chunkSize) => {
    if (chunkSize < 1)
        return [arr];
    const response = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        response.push(arr.slice(i, i + chunkSize));
    }
    return response;
};
export const removeNilProperties = (objects) => {
    return objects.map((entry) => omitBy(entry, isNil));
};
export const getRandomElement = (arr) => arr[Math.floor(Math.random() * arr.length)];
export const hasAll = (mightHave, thingsToHave) => mightHave.every((t) => thingsToHave.includes(t));
export const hasSome = (mightHave, thingsToHave) => thingsToHave.some((t) => mightHave.includes(t));
/**
 * Sort a list, ascending, given a sortable property extractor. Does not mutate original list.
 * @param extractSortableProperty Function to extract a sortable property from an item
 * @returns List sorted, ascending
 */
export const makeSortAscending = (extractSortable) => (list) => [...list].sort((left, right) => {
    const lval = extractSortable(left);
    const rval = extractSortable(right);
    return lval < rval ? -1 : rval < lval ? 1 : 0;
});
/**
 * Sort a list, descending, given a sortable property extractor. Does not mutate original list.
 * @param extractSortableProperty Function to extract a sortable property from an item
 * @returns List sorted, descending
 */
export const makeSortDescending = (extractSortable) => (list) => [...list].sort((left, right) => {
    const lval = extractSortable(left);
    const rval = extractSortable(right);
    return lval < rval ? 1 : rval < lval ? -1 : 0;
});
export const arrayOfAll = () => (array) => array;
export async function asyncForEach(array, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}
export const lengthOrZero = (maybeArray) => maybeArray?.length ?? 0;
